import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey)

if (!isSupabaseConfigured) {
  console.warn('Missing Supabase environment variables. Authentication features will be disabled.')
  console.warn('To enable authentication, create a .env file in the ui/ directory with:')
  console.warn('  VITE_SUPABASE_URL=https://your-project-ref.supabase.co')
  console.warn('  VITE_SUPABASE_ANON_KEY=your-supabase-anon-key')
}

export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
      }
    })
  : null

